import { TReconnectConfig } from '../../types/reconnection-config';
import { TrelloServiceComponent } from './TrelloServiceComponent';

export const TrelloReconnectionConfig: TReconnectConfig = {
  serviceComponent: TrelloServiceComponent,
};
